import { BaseSVGType } from '@/components/common/svg/types/svgTypes.ts';

const LockShape = ({ width, height, fillColor, style }: BaseSVGType) => {
  return (
    <svg
      fill={fillColor}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path d="M12,22a7,7,0,0,0,5-11.894V7A5,5,0,0,0,7,7v3.106A7,7,0,0,0,12,22Zm1-6.277V18a1,1,0,0,1-2,0V15.723a2,2,0,1,1,2,0ZM9,7a3,3,0,0,1,6,0V8.683a6.93,6.93,0,0,0-6,0Z" />
    </svg>
  );
};

export default LockShape;
